export default {
  postOrPatchComment(comment, axios) {
    return axios.postOrPatch('/data_api/comments', { comment })
  }
}